import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { activateDeviceResponseSchema } from '../types';

export type ActivateDeviceMutationParams = {
	cashdeskCode: string;
};

export const createActivateDeviceMutation = () =>
	createAuthMutation({
		params: declareParams<ActivateDeviceMutationParams>(),
		request: {
			method: 'POST',
			url: '/device',
			body: (data) => data,
		},
		response: {
			contract: zodContract(activateDeviceResponseSchema),
		},
	});
